import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('IssueMaterialCostController', IssueMaterialCostController);

    function IssueMaterialCostController(
        $scope,
        $rootScope,
        $state,
        FormVerificationService,
        LocalStorageService,
        MaterialCostsFactory,
        MaterialsFactory,
        CostsService
    ) {
        var vm = this;

        init();

        function init() {
            if (vm.cost && vm.cost.id) {
                vm.material = vm.cost.material || vm.cost;
                vm.material.visible_to_client = vm.cost.visible_to_client;
                vm.material.description = vm.cost.description;
            } else {
                vm.material = {};
                vm.material.quantity = 1;
                vm.material.net_price = 1;
                vm.material.vat_rate = 8;
            }

            vm.addCost = addCost;
            vm.updateCost = updateCost;
            vm.cancelCost = cancelCost;

            getMaterials();
            fillGrossValue();
        }

        function getMaterials() {
            MaterialsFactory.get(
                LocalStorageService.getObject('common/company').organization
                    .party_uuid,
                {
                    page_size: 1000,
                }
            ).then(function (response) {
                vm.materials = response.data.results;
                vm.materials.forEach(function (material) {
                    material.description = material.name;
                });
                vm.materials.unshift({
                    name: 'Dodaj nowy materiał',
                    description_visibility: true,
                });
            });
        }

        function addCost() {
            MaterialCostsFactory.create(
                LocalStorageService.getObject('common/company').organization
                    .party_uuid,
                vm.issue.id,
                vm.material
            ).then(
                function (response) {
                    $rootScope.$broadcast('cost-added', response.data);
                    refreshIssue();
                    cancelCost();
                },
                function (error) {
                    FormVerificationService.error(error.data, vm.form);
                }
            );
        }

        function updateCost() {
            MaterialCostsFactory.update(
                LocalStorageService.getObject('common/company').organization
                    .party_uuid,
                vm.issue.id,
                vm.cost.id,
                vm.material
            ).then(
                function (response) {
                    $rootScope.$broadcast(
                        'cost-changed',
                        Object.assign(vm.cost, response.data)
                    );
                    refreshIssue();
                    cancelCost();
                },
                function (error) {
                    FormVerificationService.error(error.data, vm.form);
                }
            );
        }

        function cancelCost() {
            if (vm.cost && vm.cost.material) {
                vm.material = vm.cost.material;
            } else {
                vm.cost = {};
            }
            $scope.$parent.$parent.ChangeCostsCtrl.isUserAddingCost = false;
        }

        function fillGrossValue() {
            $scope.$watch(
                function () {
                    return vm.material;
                },
                function () {
                    if (vm.material) {
                        vm.material.gross_value =
                            CostsService.calculateMaterialGrossValue(
                                vm.material.net_price,
                                vm.material.vat_rate,
                                vm.material.quantity
                            );
                    }
                },
                true
            );
        }

        function refreshIssue() {
            $state.reload('company_employee.issue_list.details');
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/company_issue_list/details/change-costs/issue-material-cost/issue-material-cost.controller.ts